import React from 'react';

const font = "'DM Sans', sans-serif";

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }

  static getDerivedStateFromError(error) { return { hasError: true, error }; }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight:'100vh', background:'#0a0a0a', color:'#fff', fontFamily:font, display:'flex', alignItems:'center', justifyContent:'center', textAlign:'center', padding:20 }}>
          <div style={{ maxWidth:400 }}>
            <p style={{ fontSize:48, margin:'0 0 16px' }}>⚠️</p>
            <h1 style={{ fontSize:22, fontWeight:500, margin:'0 0 8px' }}>Algo salió mal</h1>
            <p style={{ fontSize:14, color:'rgba(255,255,255,0.5)', lineHeight:1.6, margin:'0 0 24px' }}>
              Hubo un error inesperado. Recarga la página para continuar.
            </p>
            <button onClick={() => window.location.reload()} style={{
              background:'linear-gradient(135deg, #534AB7, #1D9E75)', color:'#fff',
              border:'none', borderRadius:50, padding:'12px 32px', fontSize:15,
              fontWeight:500, cursor:'pointer', fontFamily:font,
            }}>Recargar página</button>
            {this.state.error && (
              <p style={{ fontSize:10, color:'rgba(255,255,255,0.2)', marginTop:20, wordBreak:'break-all' }}>
                {this.state.error.message}
              </p>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
